import { mapState } from 'vuex';
import FieldValidator from '@/views/calculators/services/fieldValidatorService';
import { AccidentChildrenSettings } from '../AccidentChildrenSettings';
import ExistingAbProductsComponent from '../../components/ExistingABProductsComponent.vue';
import { Options, Vue } from 'vue-class-component';
import { PropType } from 'vue';
import { CardBlock } from '@/cms/definitions/content-types';
import { Validator } from '../../services/ValidationService';
import { handleZipCodePrefill } from '../../services/UiStepService';
import { copyAddress, mapDawaAddress, resetAddress } from '@/views/calculators/services/addressMappingService';

@Options({
	name: 'PersonInfoStepComponent',
	props: {
		card: Object as PropType<CardBlock>,
		isValid: Boolean,
	},
	components: {
		ExistingAbProductsComponent,
	},
	computed: mapState<any>({
		model: (state) => state.calculatorContext[state.calculatorContext.active].model,
		cms: (state) => state.calculatorContext[state.calculatorContext.active].cms,
	}),
})
export default class PersonInfoStepComponent extends Vue {
	card: CardBlock; // Card from cms
	isValid: boolean; // whether card is complete

	public model!: any; // data structure for user input (store)
	public cms!: AccidentChildrenSettings; // settings from CMS (store)

	public fieldValidator: FieldValidator = Validator;
	public defaultZip: string = null;
	public defaultAddress: string = null;

	public created() {
		const zipParam = (this.$route.query.zipCode as string) || (this.$route.query.zipcode as string);
		if (zipParam) {
			this.defaultZip = zipParam;
		}

		const addressParam = this.$route.query.address as string;
		if (addressParam) {
			this.defaultAddress = addressParam;
		}
	}

	public mounted() {
		handleZipCodePrefill(this.model.personInfo, this.cms);
		addEventListener('keyup', this.moveOn);
	}

	public beforeUnmount() {
		removeEventListener('keyup', this.moveOn);
	}

	public moveOn(evt) {
		if (evt.keyCode === 13 && this.isValid) {
			this.nextStep();
		}
	}

	public async addressSearch(address) {
		if (address?.matchText) {
			await mapDawaAddress(this.model.personInfo, address);
			copyAddress(this.model.personInfo, this.model.personInfo.homeAddress);

			this.model.pristineStep.set(this.card.name, true);
			return;
		}
		resetAddress(this.model.personInfo);
		resetAddress(this.model.personInfo.homeAddress);
	}

	public nextStep() {
		this.$emit('nextStep', this.card.routePath);
	}
}
